export var ClientGameSessionEvent;
(function (ClientGameSessionEvent) {
    ClientGameSessionEvent["SESSION_STATE_REFRESH"] = "session:stateRefresh";
    ClientGameSessionEvent["SESSION_JOIN"] = "session:join";
    ClientGameSessionEvent["SESSION_ASSIGN_VOTING_SCALE"] = "session:assignVotingScale";
    ClientGameSessionEvent["SESSION_INTERACTION"] = "session:interaction";
    ClientGameSessionEvent["USER_VOTE"] = "user:vote";
    ClientGameSessionEvent["USER_ROLE_UPDATE"] = "user:roleUpdate";
    ClientGameSessionEvent["ROUND_FINISH"] = "round:finish";
    ClientGameSessionEvent["ROUND_CLOSE"] = "round:close";
    ClientGameSessionEvent["ROUND_REPLAY"] = "round:replay";
})(ClientGameSessionEvent || (ClientGameSessionEvent = {}));
//# sourceMappingURL=client.js.map